import { atom } from '@zedux/react'

const businessesListAtom = atom('businessesListAtom', []);

export default businessesListAtom;